import { API_HOST } from '../../config';
import { PaymentFormV2Options, PaymentFrameEventsV2 } from '../../types';
import { paymentForm } from '../payment-form';

const PAYMENT_FRAME_V2_SEARCH_PARAMS: Record<string, string> = {
    /**
     * What's happening here?
     *
     * There are 2 AWACS balancers configured on the payment form URL.
     * By default all request are sent to trust-frontend
     * Request with `pf=1` attributes are sent to the payments-frontend
     */
    pf: '1',
};

export const paymentFormV2 = async ({ url, onDomMount, onDomUnmount, queryParams }: PaymentFormV2Options) => {
    return await paymentForm<PaymentFrameEventsV2>(API_HOST, {
        url,
        onDomMount,
        onDomUnmount,
        queryParams: {
            ...queryParams,
            ...PAYMENT_FRAME_V2_SEARCH_PARAMS,
        },
    });
};
